<template>
    <v-dialog v-model="show" max-width="560">
        <v-card>
            <v-card-title class="tit tit--xs">송장정보</v-card-title>
            <v-card-text>
                <v-select v-model="shippingInfo.method" :items="methods" item-text="text" item-value="value" label="배송방법" persistent-placeholder hide-details @input="value => { shippingInfo.invoiceNumber = null; shippingInfo.courier = value ? setting?.courierCode || null : null; }" />
                <v-text-field v-model="shippingInfo.invoiceNumber" label="운송장번호" persistent-placeholder hide-details :disabled="shippingInfo.method != `택배` && shippingInfo.method != `퀵배송`" class="mt-4" />
                <v-select v-model="shippingInfo.courier" :items="couriers" item-text="text" item-value="code" label="운송사" persistent-placeholder hide-details :disabled="shippingInfo.method != `택배` && shippingInfo.method != `퀵배송`" class="mt-4" />
            </v-card-text>
            <v-card-actions>
                <v-spacer/>
                <v-btn text color="grey" @click="close">취소</v-btn>
                <v-btn text color="primary" @click="input">확인</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
import api from "@/api";
import couriers from "@/assets/data/couriers.json";
export default {
    data(){
        return {
            show: false,
            shippingInfo: {
                method: null,
                invoiceNumber: null,
                courier: null
            },

            methods: [
                { text: "택배", value: "택배" },
                { text: "퀵배송", value: "퀵배송" },
                { text: "직접방문", value: "직접방문" },
            ],

            couriers,

            setting: null
        }
    },
    mounted(){
        this.init();
    },
    methods: {
        async init(){
            let { setting } = await api.console.shop.setting.get();
            this.setting = setting;
        },
        open(){
            this.show = true;
        },
        close(){
            this.show = false;
        },
        input(){
            this.$emit("input", this.shippingInfo);
            this.close();
        }
    },
    watch: {
        show(){
            if(!this.show) this.init();
        }
    }
}
</script>